import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useMemo, useState } from "react";
import { Button, Paragraph } from "@datagame/ui";

import { SING_IN_WITH_CODE } from "../../../../graphql/mutations/UserMutations";
import { CodeInput } from "../../../shared/ui/CodeInput";
import { StepProps } from "../Step1/Step1";
import { useSearchParams } from "react-router-dom";
import { ErrorMessage } from "../../../shared/ui/ErrorMessage";
import { useUserContext } from "../../../../contexts/user/UserContext";

import styles from "../Step1/Step1.module.scss";

export const Step2 = ({ changeStep }: StepProps) => {
  const { t } = useTranslation("account");
  const { signIn } = useUserContext();
  const [searchParams] = useSearchParams();

  const hasCode = searchParams.has("code");
  const codeValue = hasCode && searchParams.get("code");

  const [code, setCode] = useState(codeValue ? codeValue.split("") : [...Array(6)].map(() => ""));
  const [signUpWithCode, { error }] = useMutation(SING_IN_WITH_CODE);

  const handleSubmit = () => {
    signUpWithCode({
      variables: {
        code: code.join(""),
      },
      onCompleted: (data) => {
        signIn(data.signInWithCode.accessToken);
        changeStep(3);
      },
    });
  };

  const emailAddress = useMemo(() => localStorage.getItem("email"), []);

  return (
    <div>
      <Paragraph color="secondary" className={styles.description}>
        {t("step2Description1")} <b>{emailAddress}</b> {t("step2Description2")}
      </Paragraph>
      <CodeInput code={code} setCode={setCode} />
      {error && <ErrorMessage>{error.message}</ErrorMessage>}
      <Button className={styles.button} type="submit" size="large" onClick={handleSubmit}>
        {t("verifyCode")}
      </Button>
    </div>
  );
};
